import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Alert } from "../../common/Alert";
import downArrow from "../../assets/images/down-arrow.png";
import upArrow from "../../assets/images/up-arrow.png";
import editIcon from "../../assets/images/edit.png";
import FlightDetails from "../FlightDetails";
import {
  BOOKING_STATUSES,
  capitalize,
  DIMENSION_UNIT,
  DISPLAY_SERVICES,
  getDecimalFormattedNumber,
  getDensityUnit,
  getFormattedNumber,
  getRoundedValue,
  getVolumeUnit,
  getWeightUnit,
  NOTIFICATION_MESSAGE_TYPE,
  SERVICES,
  WEIGHT_UNIT,
} from "../../constants";
import { FOUR_DECIMAL_PLACES } from "../../constants/regex";
import { FORCE_QUEUE_SCC } from "../../constants/sccTypes";
import {
  default as SessionKeys,
  default as sessionKeys,
} from "../../constants/sessionKeys";
import {
  clearUpdateBooking,
  updateBooking,
} from "../../redux/actions/updateBookingActions";
import {
  clearValidateBooking,
  validateBooking,
} from "../../redux/actions/validateBookingActions";
import {
  loadListFlight,
  clearListFlight,
} from "../../redux/actions/listFlightActions";
import { getTermsConditionsByLocationResponse } from "../../services/adminMasterServices";
import {
  allowNumberOnly,
  calculateWeightFromKg,
  calculateWeightToKg,
  round,
} from "../../utils/common";
import {
  clearItemFromSessionStorage,
  getBase64Decoded,
  getBase64Encoded,
  getFromSessionStorage,
  setToSessionStorage,
} from "../../utils/StorageUtils";
import ShareEmailDialog from "../BookingConfirmation/ShareEmailDialog";
import BookingMenu from "../BookingMenu";
import LoadingIndicator from "../LoadingIndicator";
import { removeDuplicates } from "../SearchPanel/templateUtils";
import RouteDetails from "../Shared/RouteDetails";
import "./view-quote.scss";
import {
  getIsOAL,
  retriveQuoteDetails,
  triggerSaveQuote,
} from "./ViewQuoteUtils";
import { Trans, useTranslation } from "react-i18next";
import { addError, pushPageData } from "../../utils/analytics";
import pageNames from "../../constants/pageNames";
import {
  PAGE_PRIMARY_CATEGORY,
  PAGE_SUB_CATEGORY1,
  BOOKING_PAGE_SUB_CATEGORY2,
} from "../../constants";
import getCurrentUser from "../../utils/getCurrentUser";
import { sendEmailForAssistance } from "../../utils/ExceptionHandlingUtil";
import { getQuoteResponse } from "../../services/quoteServices";
import { SMALL_SCC } from "../../constants/sccTypes";
import CommonInput from "../../common/Resusable/CommonInput";
import { useLocation } from "react-router-dom";
import { getSccMaster } from "../../services/searchPanelServices";
import { useDispatch, useSelector } from "react-redux";
import { setMasterDataDetails } from "../../redux/actions/masterDataActions";
import { AlertBanner } from "../SearchPanel/AlertBanner";
import PriceUpdate from "../FlightDetails/PriceUpdate";
import MiniPopup from "../../common/Popup/MiniPopup";

const ViewQuote = ({
  setEnquiredPresent,
  updateBookingRequest,
  updateBookingResponse,
  updateBookingError,
  clearUpdateBookingResponse,
  validateBookingRequest,
  validateBookingResponse,
  validateBookingError,
  clearValidateBookingResponse,
  resultSet,
  triggerListFlight,
  triggerclearListFlight,
  isFastTrackEnabled,
}) => {
  // let { quotationId } = ''
  let { quotationName } = useParams();
  const [awbNumber, setAWBNumber] = useState("");
  const [showValidation, setshowValidation] = useState(false);
  const [pickAwb, setPickAwb] = useState(true);
  const [showSubCharges, setShowSubCharges] = useState(false);
  const [searchFormData, setSeachFormData] = useState(null);
  const [selectedFlight, setSelectedFlight] = useState(null);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [isCargoExpanded, setCargoExpanded] = useState(false);
  const [awbNo, setAWBNo] = useState("");
  const [locationCode, setLocationCode] = useState("");
  const [fileName, setFileName] = useState("");
  //share quote
  const [displayBasic, setDisplayBasic] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [status, setStatus] = useState(false);
  const [quoteExpiryTime, setQuoteExpiryTime] = useState(null);
  const [quotationDetails, setQuotationDetails] = useState(null);
  const [quoteName, setQuoteName] = useState(null);
  const [validateResponse, setValidateResponse] = useState(null);
  const [showRateDetails, setShowRateDetails] = useState(true);
  //spot rate
  const [pickAllinRate, setPickAllinRate] = useState(false);
  const [spotRate, setSpotRate] = useState("");
  const [chargeableWeight, setChargeableWeight] = useState(null);
  const [error, setError] = useState(null);
  const history = useHistory();
  const [isModifyBooking, setIsModifyBooking] = useState(null);
  const [isDetailsUpdate, setIsDetailsUpdate] = useState(null);
  const selectedBookingDetails = getFromSessionStorage("bookingDetails");

  const [warningMessages, setWarningMessages] = useState(null);
  const [infoMessages, setInfoMessages] = useState(null);
  const [disable, setDisable] = useState(false);
  const [isError, setIsError] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(null);

  const dgCheckNormal = getFromSessionStorage("ifDg");
  //for multilingual
  const { t, i18n } = useTranslation(["labels", "errors"]);
   const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';
  const userDetails = getCurrentUser();

  // Enable and awb no field

  const [awbValueEnable, setAwbValueEnable] = useState(true);

  // OAL Value




  const dgSccCode = (JSON.parse(getFromSessionStorage('dgsccCode')))
  useEffect(() => {
    if (locationCode != '') {
      locationCodeCallBack(locationCode)
    } else return
  }, [locationCode])

  const [quoteFlightResult, setQuoteFlightResult] = useState(null)

  const isInterlineAgent = getCurrentUser()?.interlineAgent === 'Y';
  const [oalValue, setOalValue] = useState(isInterlineAgent ? '' : '607')
  const location = useLocation();

  const getIsDirectFromBooking = () => {
    const encodedUpdateBookingData = getFromSessionStorage(sessionKeys.UPDATE_BOOKING_DATA);
    if (encodedUpdateBookingData) {
      const updateBookingData = getBase64Decoded(encodedUpdateBookingData);
      return updateBookingData?.isDirectSummaryFlow === true;
    }
    return false;
  };

  const [previousRatingDetails, setPreviousRatingDetails] = useState(null);
  const [queueReason, setQueueReason] = useState(null);
  const [showUpdateConfirmationPopup, setShowUpdateConfirmationPopup] = useState({ show: false, message: '' });
  const [triggerAnimation, setTriggerAnimation] = useState(false);

  const isDirectFromBooking = getIsDirectFromBooking();

  const isCopyFlow = !!(searchFormData?.isCopyFlow || location.state?.isCopyFlow);

  const [sccMaster, setSccMaster] = useState([]);
  const masterData = useSelector(state => state?.masterData);
  const dispatch = useDispatch();


  useEffect(() => {
    const fetchSccMaster = async () => {
      try {
        // const sccMasterData = await getSccMaster();
        // setSccMaster(sccMasterData.scc || []);
        let sccMasterList;
        if (masterData?.sccListMaster && masterData.sccListMaster.length > 0) {
          sccMasterList = masterData.sccListMaster;
        } else {
          const sccMasterData = await getSccMaster();
          sccMasterList = sccMasterData.scc || [];
          if (sccMasterList && sccMasterList.length > 0) {
            const masterDataPayload = {
              ...masterData,
              sccListMaster: sccMasterList,

            };
            dispatch(setMasterDataDetails(masterDataPayload));
          }
        }

        setSccMaster(sccMasterList || []);
      } catch (error) {
        console.error('Failed to fetch SCC master data:', error);
      }
    };
    fetchSccMaster();
  }, []);

  useEffect(() => {
    if (quoteFlightResult && selectedFlight) {
      const response = quoteFlightResult;
      if (
        response?.flightList?.services?.DEFAULT?.flightItineraryList &&
        response?.flightList?.services?.DEFAULT?.flightItineraryList.length > 0
      ) {
        setSelectedFlight(
          response?.flightList?.services?.DEFAULT?.flightItineraryList[0]
        );
        let encoded = getBase64Encoded(
          response?.flightList?.services?.DEFAULT?.flightItineraryList[0]
        );
        setToSessionStorage("flightSelected", encoded);
      } else if (response?.error) {
        if (response?.error?.description) {
          const encodedSearchObjectQuote = getFromSessionStorage(
            SessionKeys.SEARCH_FORM_DATA_BOOKING
          );
          const searchData = getBase64Decoded(encodedSearchObjectQuote);
          searchData.flightNumber = null;
          searchData.flightCarrierCode = null;
          setToSessionStorage(
            SessionKeys.SEARCH_FORM_DATA_BOOKING,
            getBase64Encoded(searchData)
          );
          triggerclearListFlight();
          history.push({
            pathname: "/booking/flightlist",
            state: {
              validationError: response?.error?.description,
            },
          });
        }
      }
    }
  }, [quoteFlightResult]);

  const locationCodeCallBack = async () => {
    try {
      await getTermsConditionsByLocationResponse(locationCode).then(
        (response) => {
          setFileName(response?.termsAndConditions?.fileName);
        }
      );
    } catch (error) {

      return;
    }
  };

  const getProductNameBySysCode = (productName) => masterData?.productsMaster?.find(product => product.systemProductName === productName)?.name || productName;

  const getProductName = () => {
    let productNameForDisplay = selectedFlight?.ratingDetails?.at(0)?.product || selectedFlight?.productName;
    if (isModifyBooking && productNameForDisplay) {
      productNameForDisplay = getProductNameBySysCode(productNameForDisplay)
    }
    return productNameForDisplay;
  }

  const getFlightSegment = (bookingFlightDetails) => {
    let flightSegmentList = [];
    bookingFlightDetails.map((segment) => {
      const flightSegment = {
        aircraftType: segment.aircraftType,
        combinationId: `${segment.segmentOrigin}-${segment.segmentDestination}`,
        arrivalDateTime: segment.segmentArrivalDate,
        departureDateTime: segment.segmentDepartureDate,
        flightCarrierCode: segment.carrierCode,
        flightDate: segment.flightDate,
        flightNumber: segment.flightNumber,
        flightType: segment.flightType,
        route: `${segment.segmentOrigin}-${segment.segmentDestination}`,
        segmentDestination: segment.segmentDestination,
        segmentOrigin: segment.segmentOrigin,
      };
      flightSegmentList.push(flightSegment);
      return flightSegment;
    });
    return flightSegmentList;
  };

  const getRateDetails = (rateDetails, formData) => {
    let rateDetailsList = [];
    rateDetails.map((rate) => {
      const rateDetail = {
        currency: rate.currencyCode,
        totalFreightCharge: rate.freightCharge,
        totalFreightRate: rate.rate,
        otherChargeDetails: rate.otherChargeDetails,
        totalSurcharge: rate.totalOtherCharge,
        totalCharge: rate.freightCharge,
        totalRate: rate.rate,
        totalAdditionalCharges: null,
        grandTotal: rate.totalCharge,
        product:
          selectedFlight &&
            selectedFlight.ratingDetails &&
            selectedFlight.ratingDetails.length
            ? selectedFlight.ratingDetails[0].product
            : formData &&
              formData.shippingItemCode &&
              formData.shippingItemCode.product
              ? formData.shippingItemCode.serviceProduct ||
              formData.shippingItemCode.product
              : "--",
      };
      rateDetailsList.push(rateDetail);
      return rateDetailsList;
    });

    return rateDetailsList;
  };

  const clearStorage = () => {
    clearItemFromSessionStorage("awbNumber");
    clearItemFromSessionStorage("flightSelected");
    clearItemFromSessionStorage("bookingDetails");
    clearItemFromSessionStorage("searchObject");
    clearItemFromSessionStorage("spotRate");
    clearItemFromSessionStorage("allInRate");
    clearItemFromSessionStorage("additionalFormData");
    //	clearItemFromSessionStorage('upsellOffered')
  };

  const saveQuotationDetails = (flightInfo) => {
    let quotationDetails;
    if (flightInfo && flightInfo.ratingDetails) {
      quotationDetails = {
        quotationId: flightInfo.ratingDetails[0].quotationID
          ? flightInfo.ratingDetails[0].quotationID
          : null,
        quotationGeneratedDateTime: flightInfo.ratingDetails[0]
          .quotationGeneratedDateTime
          ? flightInfo.ratingDetails[0].quotationGeneratedDateTime
          : null,
        quotationType: "dynamic",
      };
      if (quotationDetails && quotationDetails.quotationId !== null) {
        setToSessionStorage(
          "quotationDetails",
          getBase64Encoded(quotationDetails)
        );
      }
    }
  };

  useEffect(() => {
    const encodedSearchObject = getFromSessionStorage(
      SessionKeys.SEARCH_FORM_DATA_BOOKING
    );
    const encodedFlightSelected = getFromSessionStorage(
      sessionKeys.SELECTED_FLIGHT_BOOKING
    );
    if (
      (!encodedSearchObject || !encodedFlightSelected) &&
      !selectedBookingDetails &&
      !quotationName
    ) {
      return history.push("/booking/flightlist");
    }

    if (quotationName) {
      clearStorage();
      (async () => {
        try {
          let data = await retriveQuoteDetails(
            quotationName,
            setAlertMessage,
            setStatus,
            setIsLoading,
            setSeachFormData,
            setSelectedFlight
          );
          if (data.errorDescription) {
            history.push({
              pathname: "/booking/search",
              state: {
                message: "Specified quote ID not found",
                type: NOTIFICATION_MESSAGE_TYPE.ERROR,
              },
            });
            addError("FIND_QUOTE_ERROR", `${data.errorDescription}`);
            pushPageData(
              pageNames.BOOKING_SUMMARY,
              PAGE_PRIMARY_CATEGORY.E_SERVICES,
              PAGE_SUB_CATEGORY1.BOOKING,
              BOOKING_PAGE_SUB_CATEGORY2.NEW_BOOKING
            );
          } else if (data.length) {
            const encodedSearchObjectQuote = getFromSessionStorage(
              SessionKeys.SEARCH_FORM_DATA_BOOKING
            );
            const encodedFlightSelectedQuote =
              getFromSessionStorage("flightSelected");
            if (!encodedSearchObjectQuote) {
              return history.push("/booking/flightlist");
            }

            const formDataQuote = getBase64Decoded(encodedSearchObjectQuote);
            const flightSelectedQuote = getBase64Decoded(
              encodedFlightSelectedQuote
            );
            setLocationCode(formDataQuote?.origin?.countryCode);
            //setSeachFormData(formDataQuote)
            if (data[0].expiryTime) {
              setQuoteExpiryTime(data[0].expiryTime);
            }

            if (flightSelectedQuote && flightSelectedQuote.isForceQueued) {
              formDataQuote.sccCodes =
                formDataQuote.sccCodes && formDataQuote.sccCodes.length
                  ? removeDuplicates([
                    ...formDataQuote.sccCodes,
                    FORCE_QUEUE_SCC,
                  ])
                  : [FORCE_QUEUE_SCC];
              setShowRateDetails(false);
              setToSessionStorage(
                SessionKeys.SEARCH_FORM_DATA_BOOKING,
                getBase64Encoded(formDataQuote)
              );
            }
            if (flightSelectedQuote && flightSelectedQuote.departureDateTime) {
              formDataQuote.shippingDate = flightSelectedQuote.departureDateTime
                ? moment(flightSelectedQuote.departureDateTime).format(
                  "DD-MMM-YYYY"
                )
                : formDataQuote.shippingDate;
              flightSelectedQuote.shippingDate =
                flightSelectedQuote.departureDateTime
                  ? moment(flightSelectedQuote.departureDateTime).format(
                    "DD-MMM-YYYY"
                  )
                  : formDataQuote.shippingDate;
              if (
                flightSelectedQuote.flightSegmentList &&
                flightSelectedQuote.flightSegmentList.length > 0
              ) {
                formDataQuote.flightNumber = flightSelectedQuote
                  .flightSegmentList[0].flightNumber
                  ? flightSelectedQuote.flightSegmentList[0].flightNumber
                  : null;
                formDataQuote.flightCarrierCode = flightSelectedQuote
                  .flightSegmentList[0].flightCarrierCode
                  ? flightSelectedQuote.flightSegmentList[0].flightCarrierCode
                  : null;
              }

              setToSessionStorage(
                SessionKeys.SEARCH_FORM_DATA_BOOKING,
                getBase64Encoded(formDataQuote)
              );
            }
            if (
              flightSelectedQuote &&
              (flightSelectedQuote.isForceQueued ||
                flightSelectedQuote.overHangShipment ||
                flightSelectedQuote.bigShipment)
            ) {
              setShowRateDetails(false);
            }
            if (
              flightSelectedQuote &&
              flightSelectedQuote.ratingDetails &&
              flightSelectedQuote.ratingDetails.length &&
              !Number(flightSelectedQuote.ratingDetails[0].grandTotal)
            ) {
              setShowRateDetails(false);
            }
            setSeachFormData(formDataQuote);
            if (flightSelectedQuote) {
              setSelectedFlight(flightSelectedQuote);
              if (isModifyBooking || !getIsOAL(flightSelectedQuote)) {
                //validateBookingRequest(awbNo, formDataQuote, flightSelectedQuote)
                setIsLoading(true);
                //triggerListFlight(formDataQuote)
                const flightResponse = await getQuoteResponse(formDataQuote);
                setQuoteFlightResult(flightResponse);
                setTimeout(() => {
                  setIsLoading(false);
                }, 300);
              }
            }
            pushPageData(
              pageNames.BOOKING_SUMMARY,
              PAGE_PRIMARY_CATEGORY.E_SERVICES,
              PAGE_SUB_CATEGORY1.BOOKING,
              BOOKING_PAGE_SUB_CATEGORY2.NEW_BOOKING
            );
          }
        } catch (error) {

          addError("FIND_QUOTE_ERROR", error);
          pushPageData(
            pageNames.BOOKING_SUMMARY,
            PAGE_PRIMARY_CATEGORY.E_SERVICES,
            PAGE_SUB_CATEGORY1.BOOKING,
            BOOKING_PAGE_SUB_CATEGORY2.NEW_BOOKING
          );
        }
      })();
    } else {
      const formData = getBase64Decoded(encodedSearchObject);
      let flightSelected;
      if (encodedFlightSelected) {
        flightSelected = getBase64Decoded(encodedFlightSelected);
      }
      setLocationCode(formData?.origin?.countryCode);
      const { isUnknownShipment } = formData;

      let sccCodes = formData?.sccCodes ? formData.sccCodes : [];
      if (isUnknownShipment) {
        if (!sccCodes.find((e) => e.scc === "UKN")) {
          sccCodes = [...sccCodes, { scc: "UKN" }];
        }
      } else {
        sccCodes = sccCodes.filter((e) => e.scc !== "UKN");
      }

      formData.sccCodes = sccCodes;

      if (isUnknownShipment) {
        setToSessionStorage(
          SessionKeys.SEARCH_FORM_DATA_BOOKING,
          getBase64Encoded(formData)
        );
      }
      if (
        (flightSelected && flightSelected.isForceQueued) ||
        formData.adjustedWeight
      ) {
        formData.sccCodes =
          formData.sccCodes && formData.sccCodes.length
            ? removeDuplicates([...formData.sccCodes, FORCE_QUEUE_SCC])
            : [FORCE_QUEUE_SCC];
        setShowRateDetails(false);
        setToSessionStorage(
          SessionKeys.SEARCH_FORM_DATA_BOOKING,
          getBase64Encoded(formData)
        );
      }
      if (flightSelected?.previousRateDetails?.length !== 0 || flightSelected?.queuedReason) {
        if (flightSelected?.previousRateDetails?.length !== 0) { setPreviousRatingDetails(flightSelected.previousRateDetails); }
        const prevRate = flightSelected?.previousRateDetails?.[0];
        const currRate = flightSelected?.ratingDetails?.[0];
        const isRateChanged = !!Number(currRate?.totalFreightRate) && !!(
          prevRate &&
          currRate &&
          (
            getDecimalFormattedNumber(prevRate.totalFreightRate) !== getDecimalFormattedNumber(currRate.totalFreightRate)
          )
        );
        let tempQueueReason = null;
        if (flightSelected?.queuedReason) {
          tempQueueReason = { ...flightSelected.queuedReason };
          setQueueReason(tempQueueReason);
        }

        if (isRateChanged || tempQueueReason?.isQueued) {
          let msgToShow = '';
          if (isRateChanged && tempQueueReason?.isQueued) {
            msgToShow = t('BOOKING.UPDATE_BOTH_MSG');
          } else if (isRateChanged) {
            msgToShow = t('BOOKING.UPDATE_RATECHANGE_MSG');
          } else if (tempQueueReason?.isQueued) {
            msgToShow = t('BOOKING.UPDATE_QUEUE_MSG');
          }
          setShowUpdateConfirmationPopup({ show: true, message: msgToShow });
        }
      }
      if (!isDirectFromBooking && formData?.isModifyBooking && flightSelected && !flightSelected?.isForceQueued) {
        // Remove FORCE_QUEUE_SCC from sccCodes if present
        if (formData?.sccCodes && formData?.sccCodes?.length) {
          const hasErrScc = formData.sccCodes.some(
            (scc) => scc.scc === FORCE_QUEUE_SCC.scc
          );
          if (hasErrScc) {
            formData.sccCodes = formData.sccCodes.filter(
              (scc) => scc.scc !== FORCE_QUEUE_SCC.scc
            );
            setToSessionStorage(
              SessionKeys.SEARCH_FORM_DATA_BOOKING,
              getBase64Encoded(formData)
            );
          }

        }
      }
      if (
        flightSelected &&
        (flightSelected.isForceQueued ||
          flightSelected.overHangShipment ||
          flightSelected.bigShipment)
      ) {
        setShowRateDetails(false);
      }

      if (
        flightSelected &&
        flightSelected.ratingDetails &&
        flightSelected.ratingDetails.length &&
        !Number(flightSelected.ratingDetails[0].grandTotal)
      ) {
        setShowRateDetails(false);
      }
      if (
        flightSelected &&
        flightSelected.warningMessages &&
        flightSelected.warningMessages.length
      ) {
        const newWarningMessages = flightSelected.warningMessages.join(", ");
        setWarningMessages(newWarningMessages);
        if (newWarningMessages === "Minimum Handling / Connection Time Fails") {
          setDisable(true);
          setIsError(true);
          setWarningMessages(
            "Minimum Handling / Connection Time Fails. Please choose another flight."
          );
        }
        if (newWarningMessages === "Maximum Handling / Connection Time Fails") {
          setDisable(true);
          setIsError(true);
          setWarningMessages(
            "Maximum Handling / Connection Time Fails. Please choose another flight."
          );
        }
      }
      if (
        flightSelected &&
        flightSelected.infoMessages &&
        flightSelected.infoMessages.length
      ) {
        const newInfoMessages = flightSelected.infoMessages.join(", ");
        setInfoMessages(newInfoMessages);
      }

      setSeachFormData(formData);
      if (flightSelected) {
        saveQuotationDetails(flightSelected);
        setSelectedFlight(flightSelected);
        if (isModifyBooking || !getIsOAL(flightSelected)) {
          const encodedSearchObject = getFromSessionStorage(
            SessionKeys.SEARCH_FORM_DATA_BOOKING
          );

          //validateBookingRequest(awbNo, formData, flightSelected)
        }
      }

      if (selectedBookingDetails) {
        const bookingDetails = getBase64Decoded(selectedBookingDetails);
        setBookingDetails(bookingDetails);
        //setToSessionStorage('bookingDetails',bookingDetails)


        const bookingFlightDetails = bookingDetails.bookingFlightDetails;
        const rateDetails = bookingDetails.rateDetails;
        const shipmentDetails = bookingDetails.shipmentDetails;
        if (!flightSelected) {
          const flight = {
            route: `${bookingFlightDetails[0].segmentOrigin}-${bookingFlightDetails[bookingFlightDetails.length - 1]
              .segmentDestination
              }`,
            origin: bookingFlightDetails[0].segmentOrigin,
            destination:
              bookingFlightDetails[bookingFlightDetails.length - 1]
                .segmentDestination,
            arrivalDateTime:
              bookingFlightDetails[bookingFlightDetails.length - 1]
                .segmentArrivalDate,
            departureDateTime: bookingFlightDetails[0].segmentDepartureDate,
            lastAcceptanceTime: null,
            earliestDeliveryTime: null,
            dropOffAddress: shipmentDetails.dropOffAddress
              ? shipmentDetails.dropOffAddress
              : {},
            pickUpAddress: shipmentDetails.pickUpAddress
              ? shipmentDetails.pickUpAddress
              : {},
            flightSegmentList: getFlightSegment(bookingFlightDetails),
            ratingDetails: getRateDetails(rateDetails, formData),
          };
          setSelectedFlight(flight);
        }
        setIsModifyBooking(formData.isModifyBooking);
        setAWBNo(bookingDetails.awbNo);
        if (
          formData.bigShipment ||
          formData.overHangShipment ||
          formData.isForceQueued
        ) {
          setShowRateDetails(false);
        }
      } else {
        setIsModifyBooking(formData.isModifyBooking);
        setAWBNo(formData.awbNo);
      }
      const spotRateSelected = getFromSessionStorage("spotRate");
      if (spotRateSelected != null) {
        setSpotRate(spotRateSelected);
      }
      pushPageData(
        pageNames.BOOKING_SUMMARY,
        PAGE_PRIMARY_CATEGORY.E_SERVICES,
        PAGE_SUB_CATEGORY1.BOOKING,
        BOOKING_PAGE_SUB_CATEGORY2.NEW_BOOKING
      );
    }
  }, []);

  useEffect(() => {
    if (history.location.state && history.location.state.isModifyBooking) {
      setIsDetailsUpdate(history.location.state.isModifyBooking);
    }
  }, [history]);

  useEffect(() => {
    if (validateBookingResponse) {
      const response = validateBookingResponse;
      if (response.bookingDetails) {
        setValidateResponse(response.bookingDetails);
        const flight = selectedFlight;

        if (response.bookingDetails.rateDetails && flight) {
          const rateDetails = getRateDetails(
            response.bookingDetails.rateDetails,
            searchFormData
          );
          if (rateDetails) {
            flight.ratingDetails = rateDetails;
          }
        }

        if (
          response.bookingDetails.shipmentDetails &&
          response.bookingDetails.shipmentDetails.dropOffAddress &&
          flight
        ) {
          flight.dropOffAddress =
            response.bookingDetails.shipmentDetails.dropOffAddress;
        }

        if (
          response.bookingDetails.shipmentDetails &&
          response.bookingDetails.shipmentDetails.pickUpAddress &&
          flight
        ) {
          flight.pickUpAddress =
            response.bookingDetails.shipmentDetails.pickUpAddress;
        }

        const bookingCommodityDetails =
          response.bookingDetails.bookingCommodityDetails;
        if (bookingCommodityDetails && bookingCommodityDetails.length) {
          if (
            bookingCommodityDetails[0].chargeableWeight &&
            Number(
              bookingCommodityDetails[0].chargeableWeight &&
              !searchFormData.adjustedWeight
            )
          ) {
            setSeachFormData((prevState) => ({
              ...prevState,
              chargeableWeight: Number(
                bookingCommodityDetails[0].chargeableWeight
              ).toFixed(2),
            }));
            setChargeableWeight(
              Number(bookingCommodityDetails[0].chargeableWeight)
            );
          }
        }
        setSelectedFlight(flight);
        let encoded = getBase64Encoded(flight);
        setToSessionStorage("flightSelected", encoded);
        const encodedSearchObject = getFromSessionStorage(
          SessionKeys.SEARCH_FORM_DATA_BOOKING
        );

      }

      clearValidateBookingResponse();
    }
  }, [validateBookingResponse]);

  useEffect(() => {
    if (validateBookingError) {
      const error = validateBookingError;
      addError("VALIDATE_BOOKING_ERROR", error);
      if (error.description) {
        clearValidateBookingResponse();
        history.push({
          pathname: "/booking/flightlist",
          state: {
            validationError: error.description,
          },
        });
      }
    }
  }, [validateBookingError]);

  useEffect(() => {
    if (updateBookingResponse) {
      const bookingResponseDetails =
        updateBookingResponse?.responseDetails?.updatedBookingResponseDetails;
      let awbNo = `${bookingResponseDetails?.shipmentIdentifierDetails?.shipmentPrefix}-${bookingResponseDetails?.shipmentIdentifierDetails?.masterDocumentNumber}`;
      const ubrNumber = `${bookingResponseDetails?.ubrNumber}`;
      let awbNumberPath = `${bookingResponseDetails?.shipmentIdentifierDetails?.shipmentPrefix}${bookingResponseDetails?.shipmentIdentifierDetails?.masterDocumentNumber}`;
      clearUpdateBookingResponse();
      clearStorage();
      history.push({
        pathname: `/manage-booking/${awbNumberPath}/${ubrNumber}`,
        state: {
          modifyBooking: {
            status: true,
            bookingStatus: t(
              BOOKING_STATUSES[bookingResponseDetails.bookingStatus]
            ),
            awbNo: awbNo,
          },
        },
      });

      handleUpdateBooking(awbNo, updateBookingResponse);
    }
  }, [updateBookingResponse]);

  useEffect(() => {
    if (pickAwb && awbNumber != "") {
      setshowValidation(true);
    } else if (!pickAwb && awbNumber === "") {
      setshowValidation(true);
    } else {
      setshowValidation(false);
    }
  }, [pickAwb]);

  useEffect(() => {
    if (updateBookingError) {
      const errorDesc = updateBookingError.description;
      addError("UPATE_BOOKING_ERROR", errorDesc);
      clearUpdateBookingResponse();
      clearStorage();
      history.push({
        pathname: "/manage-booking/list",
        state: {
          modifyBooking: {
            status: false,
            awbNo: awbNo,
            message: errorDesc,
          },
        },
      });
    }
  }, [updateBookingError]);

  useEffect(() => {
    if (selectedFlight) {
      if (
        !selectedFlight.ratingDetails ||
        !selectedFlight.ratingDetails.length ||
        !Number(selectedFlight.ratingDetails[0]?.totalFreightCharge) ||
        !Number(selectedFlight.ratingDetails[0].grandTotal)
      ) {
        setShowRateDetails(false);
      }
      const encodedSearchObjectQuote = getFromSessionStorage(
        SessionKeys.SEARCH_FORM_DATA_BOOKING
      );
      if (encodedSearchObjectQuote) {
        const searchData = getBase64Decoded(encodedSearchObjectQuote);
        let sccCodes =
          searchData && searchData.sccCodes ? searchData.sccCodes : [];

        const hasSML =
          sccCodes.filter((sccCode) => sccCode.scc === SMALL_SCC.scc).length >
          0;
        if (selectedFlight.smallShipment) {
          if (!hasSML) {
            sccCodes.push({
              scc: SMALL_SCC.scc,
            });
          }
          searchData.sccCodes = sccCodes;

          setSeachFormData((prevState) => ({
            ...prevState,
            sccCodes: sccCodes,
          }));
          setToSessionStorage(
            SessionKeys.SEARCH_FORM_DATA_BOOKING,
            getBase64Encoded(searchData)
          );
        } else if (hasSML) {
          sccCodes = sccCodes.filter((sccCode) => {
            return sccCode.scc !== SMALL_SCC.scc;
          });
          searchData.sccCodes = sccCodes;

          setSeachFormData((prevState) => ({
            ...prevState,
            sccCodes: sccCodes,
          }));
          setToSessionStorage(
            SessionKeys.SEARCH_FORM_DATA_BOOKING,
            getBase64Encoded(searchData)
          );
        }
      }
    }
  }, [selectedFlight]);

  useEffect(() => {
    if (localStorage.getItem("Error") === "True") {
      setAlertMessage(
        "AWB stock not available. Please contact our local sales team."
      );
      localStorage.removeItem("Error");
    }
  }, []);

  if (!searchFormData || !selectedFlight) {
    return null;
  }

  const routes =
    selectedFlight && selectedFlight.flightSegmentList
      ? selectedFlight.flightSegmentList.length - 1
      : 0;

  const getFormatedTime = (value) => {
    let formattedTime = "";
    if (value) {
      let tempArray = value.split(":");
      formattedTime =
        parseInt(tempArray[0], 10) +
        "Hrs " +
        (tempArray[1] && tempArray[1] != "00" ? tempArray[1] + " Min" : "");
    }
    return formattedTime;
  };

  // const handleBookNow = () => {
  //   if (!showValidation && validateSpotRate(spotRate)) {
  //     let encodedAwbNumber = getBase64Encoded(awbNumber);
  //     setToSessionStorage("awbNumber", encodedAwbNumber);
  //     setToSessionStorage("spotRate", spotRate);
  //     setToSessionStorage("awbPrefix", oalValue);
  //     setToSessionStorage("allInRate", pickAllinRate === true ? "Y" : "N");
  //     history.push("/booking/confirmation");
  //   }
  // };

  const handleBookNow = () => {
    if (!showValidation && validateSpotRate(spotRate)) {
      let updatedFormData = { ...searchFormData };

      if (updatedFormData?.isCopyFlow && Array.isArray(sccMaster) && sccMaster.length > 0) {
        let filteredSccs = (updatedFormData.sccCodes || []).filter(scc =>
          sccMaster.some(master => master.scc === scc.scc)
        );
        const hasERR = (updatedFormData.sccCodes || []).some(scc => scc.scc === 'ERR');
        if (hasERR && !filteredSccs.some(scc => scc.scc === 'ERR')) {
          const errScc = (updatedFormData.sccCodes || []).find(scc => scc.scc === 'ERR');
          if (errScc) filteredSccs.push(errScc);
        }
        updatedFormData.sccCodes = filteredSccs;
      }
      setToSessionStorage("searchObject", getBase64Encoded(updatedFormData));
      let encodedAwbNumber = getBase64Encoded(awbNumber);
      setToSessionStorage("awbNumber", encodedAwbNumber);
      setToSessionStorage("spotRate", spotRate);
      setToSessionStorage("awbPrefix", oalValue);
      setToSessionStorage("allInRate", pickAllinRate === true ? "Y" : "N");
      history.push("/booking/confirmation");
    }
  };

  const handleSaveQuote = async () => {
    const data = await triggerSaveQuote(
      searchFormData,
      selectedFlight,
      setIsLoading,
      setAlertMessage,
      setStatus,
      quotationDetails
    );
    if (data && data.quoteDetails) {
      setQuoteName(data.quoteDetails.quoteName);
      setQuoteExpiryTime(data.quoteDetails.expiryTime);
      setDisplayBasic(true);
    } else {
      setDisplayBasic(false);
    }
  };

  const handleAlertClose = () => {
    setAlertMessage("");
    setStatus(false);
    setWarningMessages(null);
    setInfoMessages(null);
  };

  const handleUpdateConfirmationCancel = () => {
    setShowUpdateConfirmationPopup({ show: false, message: '' });
    let awbNumber = awbNo.replace("-", "").trim();
    history.push({
      pathname: `/booking/modify/${awbNumber}`,
      state: {
        isBackButtonAction: true,
      }
    });
  };

  const handleUpdateConfirmationConfirm = () => {
    setShowUpdateConfirmationPopup({ show: false, message: '' });
    setTriggerAnimation(true);
  };


  const setUpdateBooking = () => {
    let awbNumber = awbNo.replace("-", "").trim();
    const spotRate = getFromSessionStorage("spotRate");
    const allInRate = getFromSessionStorage("allInRate");
    let spotRatePayload = null;
    if (spotRate != null) {
      spotRatePayload = {
        spotRate: spotRate,
        allInRate: allInRate,
        isSpotRateRequired: "Y",
      };
    }
    updateBookingRequest(
      awbNumber,
      searchFormData,
      selectedFlight,
      spotRatePayload
    );

    //handleUpdateBooking(awbNo)
  };
  const hasAttachmentForException = true;

  const handleUpdateBooking = async (awbNo, updateBookingResponse) => {
    const attributes = getEmailAttriburtes();
    const replacements = getEmailReplacements(awbNo);
    const updateCategory =
      dgSccCode?.includes(searchFormData?.shippingItemCode?.scc) ||
        (dgCheckNormal && dgCheckNormal === "true")
        ? "dgBookingUpdate"
        : searchFormData?.shippingItemCode?.description === "Live Dogs" ||
          searchFormData?.shippingItemCode?.description === "Live Cats"
          ? "aviBookingUpdate"
          : "booking_update";
    if (
      searchFormData?.shippingItemCode?.code === "DOG" ||
      searchFormData?.shippingItemCode?.code === "CAT" ||
      dgSccCode?.includes(searchFormData?.shippingItemCode?.scc) ||
      (dgCheckNormal && dgCheckNormal === "true")
    ) {
      const response = await sendEmailForAssistance(
        updateCategory,
        null,
        attributes,
        replacements,
        selectedFlight,
        searchFormData,
        // saveBookingResponse,
        updateBookingResponse,
        awbNo,
        hasAttachmentForException
      );
    } else {
      return null;
    }
  };

  // const getEmailAttributesConfirmation = (awbNo) => {
  // 	const attributes = [
  // 		{
  // 			key: 'awbNo',
  // 			value: awbNo,
  // 		},
  // 		{
  // 			key: 'agentName',
  // 			value: userDetails ? userDetails.companyName : null,
  // 		},
  // 		{
  // 			key: 'scc',
  // 			value: searchFormData && searchFormData.sccCodes
  // 				? searchFormData.sccCodes.map((e) => e.scc).toString()
  // 				: '',
  // 		},
  // 		{
  // 			key: 'shippingItem',
  // 			value:
  // 				searchFormData && searchFormData.shippingItemCode
  // 					? `${searchFormData.shippingItemCode.description}-${searchFormData.shippingItemCode.product}`
  // 					: null,
  // 		},
  // 	]
  // 	return attributes
  // }

  // const sendConfirmationEmailForAssistance = async (
  // 	attributes,
  // 	selectedFlight,
  // 	searchFormData,
  // 	awbNo
  // ) => {
  // 	const request = await getRequest(
  // 		attributes,
  // 		selectedFlight,
  // 		searchFormData,
  // 		awbNo
  // 	)
  // 	if (request) {
  // 		const response = await sendEmail(request)
  // 			.then((response) => {
  // 				setIsLoading && setIsLoading(false)
  // 				if (response.errorDetails) {
  // 					return false
  // 				} else {
  // 					return true
  // 				}
  // 			})
  // 			.catch((error) => {
  // 				setIsLoading && setIsLoading(false)
  // 				return false
  // 			})
  // 		return response
  // 	} else {
  // 		return false
  // 	}
  // }

  // const getRequest = async (
  // 	attributes,
  // 	selectedFlight,
  // 	searchFormData,
  // 	awbNo
  // ) => {
  // 	const stationDtls = await getStationByCode(userDetails.stationCode)
  // 	const sccCodeForSubject = searchFormData && searchFormData.sccCodes
  // 		? searchFormData.sccCodes.map((e) => e.scc).toString()
  // 		: ''
  // 	const agentName = userDetails ? userDetails.companyName : null
  // 	const emailDate = selectedFlight && selectedFlight.departureDateTime
  // 		? moment(selectedFlight.departureDateTime).format('DD MMM YYYY')
  // 		: null
  // 	const originDestination = selectedFlight ? selectedFlight.origin : null
  // 	const destOrigin = selectedFlight ? selectedFlight.destination : null
  // 	const mailAttributes = {
  // 		body: `Booking Update for ${`${originDestination}`}-${`${destOrigin}`} on ${`${emailDate}`} created from portal.`,
  // 		agentCode: userDetails ? userDetails.agentCode : null,
  // 		agentName,
  // 		agentEmail: userDetails ? userDetails.email : null,

  // 	}

  // 	if (stationDtls && stationDtls.emailAddress) {
  // 		const emailAddresses = stationDtls.emailAddress.split(',')
  // 		const request = {
  // 			toEmailAddresses: emailAddresses,
  // 			subject: `Booking Modification - ${originDestination}-${destOrigin} / ${emailDate}/${sccCodeForSubject}`,
  // 			templateName: 'booking_modification_dg',
  // 			attributes: {
  // 				...mailAttributes,
  // 			},
  // 			agentCode: userDetails.agentCode,
  // 			userId: userDetails.userId,
  // 			async: false,
  // 		}
  // 		if (attributes && attributes.length) {
  // 			attributes.forEach(function (attr) {
  // 				request.attributes[attr.key] = attr.value
  // 			})
  // 		}
  // 		return request
  // 	} else {
  // 		return null
  // 	}
  // }

  const getEmailAttriburtes = () => {
    const attributes = [
      {
        key: "origin",
        value: selectedFlight ? selectedFlight.origin : null,
      },
      {
        key: "destination",
        value: selectedFlight ? selectedFlight.destination : null,
      },
      {
        key: "shippingItem",
        value:
          searchFormData && searchFormData.shippingItemCode
            ? `${searchFormData.shippingItemCode.description}-${searchFormData.shippingItemCode.product}`
            : null,
      },
      {
        key: "shippingDate",
        value:
          selectedFlight && selectedFlight.departureDateTime
            ? moment(selectedFlight.departureDateTime).format("DD-MMM-YYYY")
            : null,
      },
    ];
    return attributes;
  };

  const getEmailReplacements = (awbNo) => {
    const replacements = {
      "%FLIGHTNUMBER%":
        selectedFlight &&
          selectedFlight.flightSegmentList &&
          selectedFlight.flightSegmentList.length
          ? `${selectedFlight.flightSegmentList[0].flightCarrierCode} ${selectedFlight.flightSegmentList[0].flightCarrierId}`
          : "",
      "%FLIGHTDATE%":
        selectedFlight && selectedFlight.departureDateTime
          ? moment(selectedFlight.departureDateTime).format("DD-MMM-YYYY")
          : " ",
      "%AWB%": awbNo,
      "%ORG%": selectedFlight ? selectedFlight.origin : "",
      "%DES%": selectedFlight ? selectedFlight.destination : "",
    };
    return replacements;
  };

  const clearReferenceID = () => {
    const encodedData = getFromSessionStorage(sessionKeys.UPDATE_BOOKING_DATA);
    if (encodedData) {
      const bookingData = getBase64Decoded(encodedData);
      if (bookingData) {
        delete bookingData.referenceId;
        delete bookingData.isDirectSummaryFlow;
        setToSessionStorage(sessionKeys.UPDATE_BOOKING_DATA, getBase64Encoded(bookingData));
      }
    }
  }

  const goBack = () => {
    clearItemFromSessionStorage("bookingDetails");
    clearValidateBookingResponse();
    clearReferenceID();
    history.push("/booking/flightlist");
  };

  const goToHome = () => {
    if (isModifyBooking) {
      clearReferenceID();
      let awbNumber = awbNo.replace("-", "").trim();
      history.push({
        pathname: `/booking/modify/${awbNumber}`,
        state: {
          isBackButtonAction: true,
        }
      });
    } else {
      history.push("/booking/search");
    }
  };

  const handleBack = () => {
    let awbNumber = awbNo.replace("-", "").trim();
    if (isDirectFromBooking) {
      history.push({
        pathname: `/booking/modify/${awbNumber}`,
        state: {
          isBackButtonAction: true,
        }
      });
    } else {
      history.push({
        pathname: "/booking/flightlist",
        state: {
          modifyForm: true,
          isBackButtonAction: true,
        },
      });
    }
  };

  const handleChange = (value) => {
    if (value.length <= 8) {
      setAWBNumber(value);
      validateAWB(value);
    }
  };

  const handleChangeOAL = (value) => {
    if (value.length <= 3) {
      setOalValue(value);
    }
    if (value.length === 0 || !value) {
      setshowValidation(true);
    } else {
      setshowValidation(false);
      validateAWB(awbNumber);
    }
  };

  const handleChangeSpotRate = (value) => {
    setSpotRate(value);
  };

  const validateAWB = (value) => {
    setshowValidation(false);
    if (value) {
      if (value.length < 8) {
        setshowValidation(true);
      }
      if (value.length == 8) {
        if (value.slice(0, -1) % 7 != value[7]) {
          setshowValidation(true);
        } else if (!awbValueEnable && (oalValue.length === 0 || !oalValue)) {
          setshowValidation(true);
        }
      }
    } else if (!awbValueEnable) {
      setshowValidation(true);
    }
    // else {
    // 	setPickAwb(true)
    // }
  };

  const getChargeAmount = (element) => {
    if (element.chargeAmount) {
      return element.chargeAmount;
    } else if (element.otherChargeAmount) {
      return element.otherChargeAmount;
    } else if (element.amount) {
      return element.amount;
    };
  }

  const handlePickAwbChange = (val) => {
    setPickAwb(val);
    setAWBNumber("");
  };

  const validateSpotRate = (value) => {
    if (value && value !== null && value.trim() !== "") {
      let isValid = false;
      isValid = FOUR_DECIMAL_PLACES.test(value);
      if (!isValid) {
        setError((prevState) => ({
          ...prevState,
          spotRate: "ER213",
        }));
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  const getPetsSum = (cages) => {
    let petList = cages.map((item) => {
      return item.pets.length;
    });
    let sum = 0;
    for (const item of petList) {
      sum += item;
    }
    if (sum > 1) {
      return sum + " Pets";
    } else {
      return sum + " Pet";
    }
  };

  const getCageString = (length) => {
    let cageString = length > 1 ? "Containers" : "Container";
    return cageString;
  };


  const getAirFreightCost = () => {
    if (isModifyBooking && previousRatingDetails && previousRatingDetails.length) {
      const prevDetails = previousRatingDetails[0];
      const currDetails = selectedFlight.ratingDetails[0];

      // Format Rates (only if they exist/are not 0)
      const oldRateFormatted = Number(prevDetails.totalFreightRate)
        ? `${prevDetails.currency} ${getDecimalFormattedNumber(prevDetails.totalFreightRate)}/${getWeightUnit(WEIGHT_UNIT.KILOGRAM)}`
        : null;

      const newRateFormatted = Number(currDetails.totalFreightRate)
        ? `${currDetails.currency} ${getDecimalFormattedNumber(currDetails.totalFreightRate)}/${getWeightUnit(WEIGHT_UNIT.KILOGRAM)}`
        : null;

      // Format Amounts
      const oldAmountFormatted = `${prevDetails.currency} ${getDecimalFormattedNumber(prevDetails.totalFreightCharge)}`;
      const newAmountFormatted = `${currDetails.currency} ${getDecimalFormattedNumber(currDetails.totalFreightCharge)}`;

      // Only show PriceUpdate if old/new rate or amount differ
      if (
        getDecimalFormattedNumber(prevDetails.totalFreightRate) !== getDecimalFormattedNumber(currDetails.totalFreightRate) ||
        getDecimalFormattedNumber(prevDetails.totalFreightCharge) !== getDecimalFormattedNumber(currDetails.totalFreightCharge)
      ) {
        return (
          <PriceUpdate
            oldRate={oldRateFormatted}
            newRate={newRateFormatted}
            oldAmount={oldAmountFormatted}
            newAmount={newAmountFormatted}
            isRateAndAmountCase
            triggerAnimation={triggerAnimation}
          />
        );
      }
    }

    // Existing implementation for when there is NO previous rating
    return (
      <>
        {Number(selectedFlight.ratingDetails[0].totalFreightRate) ? (
          <div className="per-rate-field d-none d-lg-inline-block">
            {selectedFlight.ratingDetails[0].currency}{" "}
            {getDecimalFormattedNumber(
              selectedFlight.ratingDetails[0].totalFreightRate
            )}
            {"/"}
            {getWeightUnit(WEIGHT_UNIT.KILOGRAM)}
          </div>
        ) : (
          <div className="per-rate-field d-none d-lg-inline-block "></div>
        )}
        <span className="seperator d-lg-inline-block"> - </span>
        <div className="rate-field">
          <span className="d-block">
            {selectedFlight.ratingDetails[0].currency}{" "}
            {getDecimalFormattedNumber(
              selectedFlight.ratingDetails[0].totalFreightCharge
            )}
          </span>
          {Number(selectedFlight.ratingDetails[0].totalFreightRate) ? (
            <span className="per-rate-field d-block d-lg-none">
              {selectedFlight.ratingDetails[0].currency}{" "}
              {getDecimalFormattedNumber(
                selectedFlight.ratingDetails[0].totalFreightRate
              )}
              {"/"}
              {getWeightUnit(WEIGHT_UNIT.KILOGRAM)}
            </span>
          ) : (
            <></>
          )}
        </div>
      </>
    );
  };

  const getTotalCostDetails = () => {
    if (isModifyBooking && previousRatingDetails && previousRatingDetails.length) {
      const oldAmount = `${previousRatingDetails[0].currency} ${getDecimalFormattedNumber(previousRatingDetails[0].grandTotal)}`;
      const newAmount = `${selectedFlight.ratingDetails[0].currency} ${getDecimalFormattedNumber(selectedFlight.ratingDetails[0].grandTotal)}`;
      if (getDecimalFormattedNumber(previousRatingDetails[0].grandTotal) !== getDecimalFormattedNumber(selectedFlight.ratingDetails[0].grandTotal)) {
        return <PriceUpdate
          oldAmount={oldAmount}
          newAmount={newAmount}
          isRateAndAmountCase
          triggerAnimation={triggerAnimation}
        />
      }
    }
    return <>{selectedFlight && selectedFlight.ratingDetails && (
      <span>
        {selectedFlight.ratingDetails[0].currency}{" "}
        {getDecimalFormattedNumber(
          selectedFlight.ratingDetails[0].grandTotal
        )}
      </span>
    )}</>
  }

  return (
    <>
      {/* <div className="row"> */}
      {/* {isLoading ? <LoadingIndicator /> : <></>} */}
      {/* <div className="col-12"> */}
      <div className={`view-quote-page ${isRTL ? 'rtl' : ''}`}>
        {isLoading ? <LoadingIndicator /> : <></>}
        <BookingMenu activeItem={isModifyBooking ? 1 : 0} />

        {/* <div className='cargo-portal-container w-100 warning-info-wrapper'>
						{warningMessages !== null && validateResponse && (
							<Alert
								type={NOTIFICATION_MESSAGE_TYPE.WARNING}
								showAlert={true}
								message={warningMessages}
								setTimeout={false}
								isError={isError}
								onAlertClose={handleAlertClose}
								timeOut={10000}
							/>
						)}
					</div> */}

        {/* <div className='cargo-portal-container w-100 warning-info-wrapper pt-0'>
						{infoMessages !== null && validateResponse && (
							<Alert
								type={NOTIFICATION_MESSAGE_TYPE.INFO}
								showAlert={true}
								message={infoMessages}
								setTimeout={true}
								onAlertClose={handleAlertClose}
								timeOut={10000}
							/>
						)}
					</div> */}
        <div className="cargo-portal-container w-100 warning-info-wrapper pt-0">
          {alertMessage !== "" && status !== null && (
            <Alert
              type={NOTIFICATION_MESSAGE_TYPE.ERROR}
              isError={!status}
              showAlert={true}
              message={alertMessage}
              setTimeout={true}
              onAlertClose={handleAlertClose}
            />
          )}
        </div>
        {queueReason && queueReason.isQueued && (<AlertBanner type={"warning"} mainMessage={queueReason.reason?.length ? `${t("BOOKING.BOOKING_QUEUED_REASON")} ${queueReason?.reason?.join(', ')}` : t("BOOKING.BOOKING_QUEUED")} className="queued-alert-banner" />)}
        <ShareEmailDialog
          selectedFlight={selectedFlight}
          searchFormData={searchFormData}
          getFormatedTime={getFormatedTime}
          displayBasic={displayBasic}
          setDisplayBasic={setDisplayBasic}
          screenName="QUOTE"
          quoteExpiryTime={quoteExpiryTime}
          quoteName={quoteName}
        />
        <div className="quote-details">
          <div className="header-container">
            <div className="title-container">
              <div className="summary_title">{t("BOOKING.SUMMARY")}</div>
              {!isModifyBooking && (
                // <div class="col-auto col-md-6 text-right d-none d-md-block">
                <button
                  type="button"
                  className="secondary-button share-quote-button d-none d-md-block"
                  onClick={() => handleSaveQuote()}
                >
                  {t("BOOKING_SUMMARY.SHARE_QUOTE")}
                </button>
                // </div>
              )}

            </div>

            <div class="shipment-summary-container">
              <div class="shipment-summary-items">
                {isModifyBooking && (
                  <>

                    <div class="shipment-summary-item">
                      <div className="orgin-dest"> {t("COMMON.AWB_NUMBER")}</div>
                      <div className="orgin-dest-code">
                        {awbNo?.replace(/\s+/g, '').replace(/^(\d{3})(\d+)$/, '$1-$2')}
                      </div>
                    </div>
                    <div className="divider-shipment"></div>
                  </>
                )}

                <div class="shipment-summary-item">
                  <div className="orgin-dest"> {t("CHOOSE_FLT.ORGIN_DESTINATION")}</div>
                  <div className="orgin-dest-code">
                    {searchFormData && searchFormData.origin
                      ? searchFormData.origin.code
                      : ""}
                    {" - "}
                    {searchFormData && searchFormData.destination
                      ? searchFormData.destination.code
                      : ""}
                  </div>
                </div>


                <div className="divider-shipment"></div>

                <div class="shipment-summary-item">
                  <div className="orgin-dest"> {t("PERMANENT_BOOKING.SHIPPING_DATE")}</div>
                  <div className="orgin-dest-code">
                    {selectedFlight && selectedFlight.departureDateTime
                      ? moment(
                        selectedFlight.departureDateTime,
                        "DD-MMM-YYYY"
                      ).format("ddd Do MMM")
                      : ""}
                  </div>
                </div>

              </div>
            </div>

          </div>

          {/* {!isModifyBooking && (
                  <span className="share_quote d-flex d-md-none">
                    <button
                      type="button"
                      className="secondary-button"
                      onClick={() => handleSaveQuote()}
                    >
                      {t("BOOKING_SUMMARY.SHARE_QUOTE")}
                    </button>
                  </span>
                )} */}

          {/* <a
                    className="shipment-summary__item__right d-lg-none"
                    onClick={() => goBack()}
                  >
                    {!isModifyBooking && (
                      <>
                        <span className="shipment-summary_modify-mobile">
                          <img
                            src={editIcon}
                            alt="modify-mobile"
                            title="modify-mobile"
                          />
                        </span>
                      </>
                    )}
                  </a> */}

          {/* <div className="col-12 text-right modify">
              <a className="modify-styling" onClick={() => goBack()}>
                {!isModifyBooking && (
                  <span
                    id="modify-position"
                    className="d-none d-lg-inline-block"
                  >
                    {t("COMMON.MODIFY")}
                  </span>
                )}
                {isModifyBooking && (
                  <span className="l-link">{t("COMMON.SEARCHFLIGHT")}</span>
                )}
              </a>
            </div> */}
          <div className="flight-details-container">
            <div className="flight-deatils-edit-header">
              <div className="sub-title-flight-deatils">{t("VIEWBKG.FLIGHT_DTS")}</div>

              {isModifyBooking && (
                <button
                  type='button'
                  className='modify-button'
                  onClick={() => goBack()}
                >
                  {t("COMMON.EDIT")}
                </button>
              )}
              {!isModifyBooking && (
                <button
                  type='button'
                  className='modify-button'
                  onClick={() => goBack()}
                >
                  {t("COMMON.EDIT")}
                </button>
              )}

              {/* <div className="modify">
                <a className="modify-styling" onClick={() => goBack()}>
                  {!isModifyBooking && (
                    <span
                      id="modify-position"
                      
                    >
                      {t("COMMON.EDIT")}
                    </span>
                  )}
                  {isModifyBooking && (
                    <span id="modify-position">{t("COMMON.EDIT")}</span>
                  )}
                </a>
              </div> */}
            </div>

            {selectedFlight && (
              <div className="w-100">
                <FlightDetails
                  setEnquiredPresent={setEnquiredPresent}
                  destinationAirport={{
                    ...selectedFlight,
                    service: isFastTrackEnabled
                      ? SERVICES.FAST_TRACK
                      : selectedFlight.service,
                  }}
                  showChooseButton={false}
                  showDropoffPickup={false}
                  showRightSection={true}
                  showFooter={true}
                  previousRatingDetails={previousRatingDetails}
                  isDirectFromBooking={isDirectFromBooking}
                  triggerAnimation={triggerAnimation}
                />
              </div>
            )}
          </div>

          <div className="cargo-details-container d-none d-lg-flex">
            <div className="flight-deatils-edit-header">
              <div className="sub-title-flight-deatils">{t("COMMON.CARGO_DTLS")}</div>

              {isModifyBooking && (
                <button
                  type='button'
                  className='modify-button'
                  onClick={() => goToHome()}
                >
                  {t("COMMON.EDIT")}
                </button>
              )}
              {!isModifyBooking && (
                <button
                  type='button'
                  className='modify-button'
                  onClick={() => goToHome()}
                >
                  {t("COMMON.EDIT")}
                </button>
              )}


            </div>
            <div className="cargo-details">
              <div className="cargo-details-row">
                <div className="cargo-details-item">
                  <div className="item">{searchFormData.shippingItemCode.code === "DOG" ||
                    searchFormData.shippingItemCode.code === "CAT"
                    ? t("COMMON.QTY")
                    : t("COMMON.PCS")}</div>
                  <div className="value">
                    {searchFormData.shippingItemCode.code === "DOG" ||
                      searchFormData.shippingItemCode.code === "CAT"
                      ? searchFormData.crates &&
                        searchFormData.crates[0]?.weight
                        ? `${getPetsSum(searchFormData.crates)} in ${searchFormData.crates.length
                        } ${getCageString(searchFormData.crates.length)}`
                        : ""
                      : getFormattedNumber(searchFormData.totalPieces)}
                  </div>

                </div>
                <div className="cargo-details-item">
                  <div className="item">{t("COMMON.GROSS_WT")}</div>
                  {/* <div className="value">00</div> */}
                  <div className="d-flex">
                    <div className="value">
                      {searchFormData.grossWeightInSelectedUnit}
                      {getWeightUnit(searchFormData.weightUnit)}
                    </div>
                    {searchFormData.weightUnit &&
                      searchFormData.weightUnit != WEIGHT_UNIT.KILOGRAM ? (
                      <div className="value">
                        ({searchFormData.grossWeightInConvertedUnit}
                        {getWeightUnit(WEIGHT_UNIT.KILOGRAM)})
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>

                </div>
                <div className="cargo-details-item">
                  <div className="item">{t("COMMON.VOL")}</div>
                  {searchFormData.dimensionUnit ===
                    DIMENSION_UNIT.CENTIMETERS ? (
                    <div className="value">
                      {getDecimalFormattedNumber(
                        searchFormData.totalVolumeInMtrs
                      )}
                      {getVolumeUnit(DIMENSION_UNIT.METERS)}
                    </div>
                  ) : (
                    <>
                      <div className="value">
                        {getDecimalFormattedNumber(
                          searchFormData.actualVolume
                        )}
                        {getVolumeUnit(searchFormData.dimensionUnit)}
                      </div>
                      <div className="value">
                        (
                        {getDecimalFormattedNumber(
                          searchFormData.totalVolumeInMtrs
                        )}
                        {getVolumeUnit(DIMENSION_UNIT.METERS)})
                      </div>
                    </>
                  )}{" "}
                  {/* <div className="value">00</div> */}

                </div>
                <div className="cargo-details-item">
                  <div className="item">{t("COMMON.DENSITY")}</div>
                  <div className="d-flex">
                    {searchFormData.dimensionUnit ===
                      DIMENSION_UNIT.CENTIMETERS ? (
                      <div className="value">
                        {searchFormData.densityInSelectedUnit}
                        {getDensityUnit(
                          searchFormData.weightUnit,
                          DIMENSION_UNIT.METERS
                        )}
                      </div>
                    ) : (
                      <div className="value">
                        {searchFormData.densityInSelectedUnit}
                        {getDensityUnit(
                          searchFormData.weightUnit,
                          searchFormData.dimensionUnit
                        )}
                      </div>
                    )}
                    {searchFormData.densityInConvertedUnit &&
                      ((searchFormData.weightUnit &&
                        searchFormData.weightUnit !== WEIGHT_UNIT.KILOGRAM) ||
                        searchFormData.dimensionUnit !==
                        DIMENSION_UNIT.CENTIMETERS) ? (
                      <div className="value">
                        ({searchFormData.densityInConvertedUnit}
                        {getDensityUnit(
                          WEIGHT_UNIT.KILOGRAM,
                          DIMENSION_UNIT.METERS
                        )}
                        )
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>

                </div>
              </div>
              <div className="cargo-details-row">
                <div className="cargo-details-item">
                  <div className="item">{t("COMMON.PRD")}</div>
                  <div className="value">
                    {getProductName()}
                  </div>

                </div>
                <div className="cargo-details-item">
                  <div className="item">{t("COMMON.COMMODITY")}</div>
                  <div className="value">
                    {searchFormData.shippingItemCode.description}
                  </div>

                </div>
                <div className="cargo-details-item">
                  <div className="item">{t("COMMON.SCC_LABEL")}</div>
                  <div className="value">
                    {/* {(() => {
                        let sccs = searchFormData && searchFormData.sccCodes;
                        // if (selectedFlight && selectedFlight.service) {
                        // sccs = [...sccs, { scc: selectedFlight.service }]
                        // }
                        return sccs.map((e) => e.scc).join(", ");
                      })()} */}
                    {(() => {
                      let sccs = searchFormData && searchFormData.sccCodes ? searchFormData.sccCodes : [];
                      const isCopyFlow = searchFormData?.isCopyFlow;
                      const hasERR = sccs.some(scc => scc.scc === 'ERR');
                      let filteredSccs = sccs;
                      if (isCopyFlow && sccMaster.length > 0) {
                        filteredSccs = sccs.filter(scc =>
                          sccMaster.some(master => master.scc === scc.scc)
                        );

                        if (hasERR && !filteredSccs.some(scc => scc.scc === 'ERR')) {
                          const errScc = sccs.find(scc => scc.scc === 'ERR');
                          if (errScc) filteredSccs.push(errScc);
                        }
                      }
                      return filteredSccs.map((e) => e.scc).join(", ");
                    })()}
                  </div>

                </div>
                <div className="cargo-details-item">
                  <div className="item">{t("COMMON.SERVICE")}</div>
                  <div className="value">
                    {selectedFlight && selectedFlight.service
                      ? selectedFlight.service &&
                        selectedFlight.service == SERVICES.FAST_TRACK
                        ? DISPLAY_SERVICES[SERVICES.FAST_TRACK]
                        : null
                      : "--"}
                  </div>

                </div>
              </div>
              <div className="cargo-details-row">

                {searchFormData &&
                  searchFormData &&
                  searchFormData?.unid &&
                  searchFormData?.unid[0]?.unid !== "" &&
                  searchFormData.shippingItemCode.product !== "LiveAnimals" &&
                  dgCheckNormal === "true" ? (

                  <div className="cargo-details-item">
                    <div className="item">{t("COMMON.UNIDSUMMARY")}</div>
                    <div className="value">

                      {searchFormData && searchFormData.unid
                        ? searchFormData?.unid?.map((e, index) =>
                          searchFormData?.unid?.length - 1 === index
                            ? `${e?.unid}`
                            : `${e?.unid}, `
                        )
                        : "--"}
                    </div>
                  </div>


                ) : (
                  <></>
                )}

                <div className='cargo-details-item'>
                  <div className='item'>{t('COMMON.CH_WT')}</div>

                  {searchFormData.weightUnit &&
                    searchFormData.weightUnit != WEIGHT_UNIT.KILOGRAM ? (
                    <div className="d-flex">
                      <div className='value'>
                        {searchFormData
                          ? getRoundedValue(chargeableWeight || searchFormData.chargeableWeight)
                          : ''}
                        {getWeightUnit(searchFormData.weightUnit)}
                      </div>
                      <div className='value'>
                        ({searchFormData
                          ? round(
                            calculateWeightToKg(
                              chargeableWeight || searchFormData.chargeableWeight,
                              searchFormData.weightUnit
                            ), 2
                          )
                          : ''}
                        {getWeightUnit(WEIGHT_UNIT.KILOGRAM)})
                      </div>
                    </div >
                  ) : (
                    <div className='value'>
                      {searchFormData
                        ? getRoundedValue(chargeableWeight || searchFormData.chargeableWeight)
                        : ''}
                      {getWeightUnit(WEIGHT_UNIT.KILOGRAM)}
                    </div>
                  )}
                </div>
              </div>


            </div>

          </div>

          <div className="mobile_partition-wrap border-top-0 d-flex d-lg-none border-bottom-0 mt-4">
            <div
              className="mobile_partition-row p-0 mobile-partition-cargo-deatils"
            //       onClick={() => setCargoExpanded(!isCargoExpanded)}
            >
              <span className="mobile_partition-title ">
                {t("COMMON.CARGO_DTLS")}
              </span>
              <div className="modify">
                <a className="modify-styling" onClick={() => goToHome()}>
                  {!isModifyBooking && (
                    <span
                      id="modify-position"
                    // className="d-none d-lg-inline-block"
                    >
                      {t("COMMON.EDIT")}
                    </span>
                  )}
                  {/* {isModifyBooking && (
                      <span className="l-link">{t("COMMON.SEARCHFLIGHT")}</span>
                    )} */}
                </a>
              </div>
              {/* <span className="mobile_partition-icon">
                  <i>
                    {isCargoExpanded ? (
                      <img src={upArrow} alt="Flight" title="Flight" />
                    ) : (
                      <img src={downArrow} alt="Flight" title="Flight" />
                    )}
                  </i>
                </span> */}
            </div>
            {/* {isCargoExpanded ? ( */}
            <div className="mobile_partition-expanded  row">
              <div className="col-6">
                {searchFormData && (
                  <>
                    <div className="cargo-item">
                      <label>
                        {" "}
                        {searchFormData.shippingItemCode.code === "DOG" ||
                          searchFormData.shippingItemCode.code === "CAT"
                          ? t("COMMON.QTY")
                          : t("COMMON.PCS")}
                        :{" "}
                      </label>

                      <div className="value-field">
                        {searchFormData.shippingItemCode.code === "DOG" ||
                          searchFormData.shippingItemCode.code === "CAT"
                          ? searchFormData.crates &&
                            searchFormData.crates[0]?.weight
                            ? `${getPetsSum(searchFormData.crates)} in ${searchFormData.crates.length
                            } ${getCageString(
                              searchFormData.crates.length
                            )}`
                            : ""
                          : getFormattedNumber(searchFormData.totalPieces)}
                      </div>
                    </div>
                    <div className="cargo-item">
                      <label>{t("COMMON.GROSS_WT")}</label>
                      <>
                        <div className="value-field p-r-5">
                          {searchFormData.grossWeightInSelectedUnit}
                          {getWeightUnit(searchFormData.weightUnit)}
                        </div>
                        {searchFormData.weightUnit &&
                          searchFormData.weightUnit != WEIGHT_UNIT.KILOGRAM ? (
                          <div className="value-field value-field__sub">
                            ({searchFormData.grossWeightInConvertedUnit}
                            {getWeightUnit(WEIGHT_UNIT.KILOGRAM)})
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    </div>
                    <div className="cargo-item">
                      <label>{t("COMMON.VOL")}</label>
                      {searchFormData.dimensionUnit ===
                        DIMENSION_UNIT.CENTIMETERS ? (
                        <div className="value-field p-r-5">
                          {getDecimalFormattedNumber(
                            searchFormData.totalVolumeInMtrs
                          )}
                          {getVolumeUnit(DIMENSION_UNIT.METERS)}
                        </div>
                      ) : (
                        <>
                          <div className="value-field p-r-5">
                            {getDecimalFormattedNumber(
                              searchFormData.actualVolume
                            )}
                            {getVolumeUnit(searchFormData.dimensionUnit)}
                          </div>
                          <div className="value-field value-field__sub">
                            (
                            {getDecimalFormattedNumber(
                              searchFormData.totalVolumeInMtrs
                            )}
                            {getVolumeUnit(DIMENSION_UNIT.METERS)})
                          </div>
                        </>
                      )}{" "}
                    </div>
                    <div className="cargo-item">
                      <label>{t("COMMON.DENSITY")}</label>
                      {searchFormData.dimensionUnit ===
                        DIMENSION_UNIT.CENTIMETERS ? (
                        <div className="value-field p-r-5">
                          {searchFormData.densityInSelectedUnit}
                          {getDensityUnit(
                            searchFormData.weightUnit,
                            DIMENSION_UNIT.METERS
                          )}
                        </div>
                      ) : (
                        <div className="value-field p-r-5">
                          {searchFormData.densityInSelectedUnit}
                          {getDensityUnit(
                            searchFormData.weightUnit,
                            searchFormData.dimensionUnit
                          )}
                        </div>
                      )}
                      {searchFormData.densityInConvertedUnit &&
                        ((searchFormData.weightUnit &&
                          searchFormData.weightUnit !== WEIGHT_UNIT.KILOGRAM) ||
                          searchFormData.dimensionUnit !==
                          DIMENSION_UNIT.CENTIMETERS) ? (
                        <div className="value-field value-field__sub">
                          ({searchFormData.densityInConvertedUnit}
                          {getDensityUnit(
                            WEIGHT_UNIT.KILOGRAM,
                            DIMENSION_UNIT.METERS
                          )}
                          )
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                )}
              </div>
              <div className="col-6">
                <div className="cargo-item">
                  <label>{t("COMMON.PRD")}</label>
                  <div className="value-field">
                    {selectedFlight &&
                      selectedFlight.ratingDetails &&
                      selectedFlight.ratingDetails.length
                      ? selectedFlight.ratingDetails[0].product
                      : ""}
                  </div>
                </div>
                <div className="cargo-item">
                  <label className="">{t("COMMON.COMMODITY")}</label>
                  <div className="value-field">
                    {searchFormData.shippingItemCode.description}
                  </div>
                </div>
                {/* <div className="cargo-item">
                    <label>{t("COMMON.SCC_LABEL")}</label>
                    <div className="value-field">
                      {(() => {
                        let sccs = searchFormData && searchFormData.sccCodes;
                        // if (selectedFlight && selectedFlight.service) {
                        // 	sccs = [...sccs, { scc: selectedFlight.service }]
                        // }
                        return sccs.map((e) => e.scc).toString();
                      })()}
                    </div>
                  </div> */}
                <div className="cargo-item">
                  <label>{t("COMMON.SCC_LABEL")}</label>
                  <div className="value-field">
                    {(() => {
                      let sccs = searchFormData && searchFormData.sccCodes ? searchFormData.sccCodes : [];
                      const isCopyFlow = searchFormData?.isCopyFlow;
                      const hasERR = sccs.some(scc => scc.scc === 'ERR');
                      let filteredSccs = sccs;
                      if (isCopyFlow && sccMaster.length > 0) {
                        filteredSccs = sccs.filter(scc =>
                          sccMaster.some(master => master.scc === scc.scc)
                        );

                        if (hasERR && !filteredSccs.some(scc => scc.scc === 'ERR')) {
                          const errScc = sccs.find(scc => scc.scc === 'ERR');
                          if (errScc) filteredSccs.push(errScc);
                        }
                      }
                      return filteredSccs.map((e) => e.scc).join(", ");
                    })()}
                  </div>
                </div>
                <div className="cargo-item">
                  <label>{t("COMMON.SERVICE")}</label>
                  <div className="value-field">
                    {selectedFlight && selectedFlight.service
                      ? selectedFlight.service &&
                        selectedFlight.service == SERVICES.FAST_TRACK
                        ? DISPLAY_SERVICES[SERVICES.FAST_TRACK]
                        : null
                      : "--"}
                  </div>
                </div>
                {searchFormData &&
                  searchFormData?.unid &&
                  searchFormData?.unid[0]?.unid !== "" &&
                  dgCheckNormal === "true" ? (
                  <div className="cargo-item">
                    <label className="col-md-5">
                      {t("COMMON.UNIDSUMMARY")}
                    </label>
                    <div className="value-field">
                      {searchFormData && searchFormData?.unid
                        ? searchFormData?.unid?.map((e, index) =>
                          searchFormData?.unid?.length - 1 === index
                            ? `${e?.unid}`
                            : `${e.unid}, `
                        )
                        : "--"}
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
            {/* ) : (
                <></>
              )} */}
          </div>
          {showRateDetails &&
            ((getIsOAL(selectedFlight) && !isModifyBooking) ||
              selectedFlight ||
              (bookingDetails && isModifyBooking)) ? (
            <div className="cargo-details-container">

              <div className="charges-header">
                {t("COMMON.CHARGES")}
              </div>

              {isInterlineAgent ? <div className='no-rate'>{t('COMMON.NO_RATES')}</div>
                :
                <div className="booking-details">
                  <div className="d-flex justify-content-between row p-l-0">
                    <div>
                      <h4>{t("COMMON.CH_WT")}</h4>
                    </div>

                    <div className="charge-weight ">
                      {searchFormData.weightUnit &&
                        searchFormData.weightUnit != WEIGHT_UNIT.KILOGRAM ? (
                        <>
                          <span className="p-r-5">
                            {searchFormData
                              ? getRoundedValue(
                                chargeableWeight ||
                                searchFormData.chargeableWeight
                              )
                              : 0.0}
                            {getWeightUnit(searchFormData.weightUnit)}
                          </span>
                          <span className="value-field value-field__sub">
                            (
                            {searchFormData
                              ? round(
                                calculateWeightToKg(
                                  chargeableWeight ||
                                  searchFormData.chargeableWeight,
                                  searchFormData.weightUnit
                                ),
                                2
                              )
                              : 0.0}
                            {getWeightUnit(WEIGHT_UNIT.KILOGRAM)})
                          </span>
                        </>
                      ) : (
                        <span>
                          {searchFormData
                            ? getRoundedValue(
                              chargeableWeight ||
                              searchFormData.chargeableWeight
                            )
                            : ""}
                          {getWeightUnit(WEIGHT_UNIT.KILOGRAM)}
                        </span>
                      )}
                    </div>
                  </div>

                  {selectedFlight && selectedFlight.ratingDetails && (
                    <div className="row justify-content-between d-flex">
                      <div className=" charges-row">
                        <h4>{t("COMMON.AIR_FREIGHT_COST")}</h4>
                      </div>
                      {getAirFreightCost()}
                    </div>
                  )}

                  {selectedFlight &&
                    selectedFlight.ratingDetails &&
                    selectedFlight.ratingDetails.length &&
                    Number(selectedFlight.ratingDetails[0].grandTotal) ? (
                    <div className="d-flex justify-content-between row subcharges p-l-0">
                      <div className="col-auto col-md-9 p-l-0 charges-row">
                        <h4>
                          {t("COMMON.SURCHARGES")}
                          {selectedFlight.ratingDetails[0].otherChargeDetails &&
                            selectedFlight.ratingDetails[0].otherChargeDetails
                              .length > 0 &&
                            selectedFlight?.ratingDetails[0]?.totalSurcharge !==
                            null && (
                              <span
                                className={`plus-sign ${isRTL ? 'rtl' : ''}`}
                                onClick={() =>
                                  setShowSubCharges(!showSubCharges)
                                }
                              >
                                <i>
                                  <FontAwesomeIcon
                                    icon={showSubCharges ? faMinus : faPlus}
                                  />
                                </i>
                              </span>
                            )}
                        </h4>{" "}
                      </div>
                      <div>
                        <span className="rate-field" id="charges-styling">
                          {selectedFlight.ratingDetails[0].currency}{" "}
                          {selectedFlight.ratingDetails[0].totalSurcharge ===
                            null
                            ? "0"
                            : getDecimalFormattedNumber(
                              selectedFlight.ratingDetails[0].totalSurcharge
                            )}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  {selectedFlight &&
                    selectedFlight.ratingDetails &&
                    selectedFlight.ratingDetails[0].otherChargeDetails &&
                    selectedFlight.ratingDetails[0].otherChargeDetails.length &&
                    showSubCharges ? (
                    selectedFlight.ratingDetails[0].otherChargeDetails.map(
                      (element, index) => {
                        return (
                          <div className="d-flex justify-content-between row border-bottom-0 p-l-0">
                            <div className="w-60 p-l-0 charges-row p-t-0">
                              {element.chargeHeadName && (
                                <h4>{capitalize(element.chargeHeadName)} </h4>
                              )}
                              {element.name && (
                                <h4>{capitalize(element.name)} </h4>
                              )}
                            </div>
                            <div className="per-rate-field d-none d-lg-inline-block p-r-0"></div>
                            <div
                              className="rate-field  p-r-0 "
                              id="charges-styling"
                            >
                              {selectedFlight.ratingDetails[0].currency}{" "}
                              {getDecimalFormattedNumber(
                                getChargeAmount(element)
                              )}
                            </div>
                          </div>
                        );
                      }
                    )
                  ) : (
                    <></>
                  )}

                  <div className="d-flex justify-content-between row total">
                    <div className="total-cost">
                      <h4>{t("COMMON.TTL_CST")}</h4>
                      <div>
                        {getTotalCostDetails()}
                      </div>
                    </div>
                    <div className="exclude-text col-12 p-l-0 pr-0">
                      {fileName && fileName !== "" ? (
                        <React.Fragment>
                          <Trans
                            i18nKey={t("ER130", { ns: "errors" })}
                            t={t}
                            components={[
                              <a
                                className="l-link"
                                href={
                                  fileName && fileName.length
                                    ? `/media/${fileName}`
                                    : "/"
                                }
                                role="button"
                                target="_blank"
                                rel="noreferrer"
                              >
                                {" "}
                              </a>,
                            ]}
                          />
                          {/* Additional charges may apply. Please read our&nbsp;
													<a
														className='l-link'
														href={
															fileName && fileName.length
																? `/media/${fileName}`
																: '/'
														}
														role='button'
														target='_blank'
														rel='noreferrer'
													>
														terms and conditions
													</a>
													&nbsp;for more information. */}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {t("COMMON.ADDITIONAL_CHARGES_MSG")}
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </div>}
            </div>
          ) : (
            <></>
          )}
          {!showRateDetails &&
            ((!isModifyBooking && getIsOAL(selectedFlight)) ||
              selectedFlight ||
              (bookingDetails && isModifyBooking)) ? (

            <div className="cargo-details-container">
              <div className="charges-header">
                {t("COMMON.CHARGES")}
              </div>
              <div className=" no-rate">
                {t("COMMON.NO_RATES")}
              </div>

            </div>
          ) : (
            <></>
          )}


          {!isModifyBooking ? (
            selectedFlight &&
              selectedFlight.priceClass &&
              selectedFlight.priceClass === "ADHOC_RATE" ? (
              <></>
            ) : (
              <>
                {!isInterlineAgent && (
                  <div className="request-spot-rate-container">
                    <div className="request-spot-header">
                      {t("BOOKING_SUMMARY.REQUEST_SPOT")}
                    </div>
                    <div className="awbSpotWrap">
                      <div className="awb-details">

                        <div className="spot-rate-section">
                          <CommonInput
                            type="text"
                            id="spotRate"
                            label={t("COMMON.SPOT_RATE")}
                            // className="spot-rate-section"
                            value={spotRate}
                            onChange={(e) => handleChangeSpotRate(e.target.value)}
                            onKeyDown={(evt) => allowNumberOnly(evt)}
                            onFocus={(e) => setError(null)}
                            onBlur={(e) => validateSpotRate(e.target.value)}
                            error={
                              error && error["spotRate"]
                                ? t(error["spotRate"], { ns: "errors" })
                                : null
                            }
                          />
                        </div>
                        <div className="l-checkbox">
                          <input
                            id={`allInRate`}
                            type="checkbox"
                            onChange={(e) => setPickAllinRate(e.target.checked)}
                          />
                          <label className="mb-0" htmlFor={`allInRate`}>
                            {t("COMMON.ALL_INCLUSIVE")}
                          </label>
                        </div>

                      </div>

                      <div
                        className=""
                        id="text-font-style"
                      >
                        <Trans i18nKey={t("COMMON.SPOT_RATE_TXT")} />
                      </div>

                    </div>
                  </div>
                )}
              </>
            )
          ) : (
            <></>
          )}

          {!isModifyBooking && (
            <div className="awb-details-container">
              <div className="awb-header">
                {t("COMMON.AWB_DTLS")}
              </div>
              <div className="awbSpotWrap-container">
                <div className="l-checkbox">
                  <input
                    id="pickAWB"
                    type="checkbox"
                    checked={!isInterlineAgent && pickAwb}
                    disabled={isInterlineAgent}
                    onChange={(e) => {
                      if (!isInterlineAgent) {
                        setOalValue("607");
                        handlePickAwbChange(e.target.checked);

                        if (e.target.checked) {
                          setAwbValueEnable(true);
                        } else {
                          setAwbValueEnable(false);
                        }
                      }
                    }}
                  // onChange={(e) => {
                  //   if (!isInterlineAgent) {              
                  //     setOalValue("607");
                  //     handlePickAwbChange(e.target.checked);
                  //     setAwbValueEnable(e.target.checked);
                  //   }
                  // }}
                  />
                  <label htmlFor="pickAWB" className="mb-0">
                    {t("BOOKING_SUMMARY.AUTOPICK_AWB")}
                  </label>
                </div>

                <div className="awb-container">
                  <div className="form-group awb-input-section">
                    <CommonInput
                      type="number"
                      label={t("COMMON.PREFIX")}
                      value={awbValueEnable && !isInterlineAgent ? "607" : oalValue}
                      disabled={!isInterlineAgent && awbValueEnable}
                      onChange={(e) => handleChangeOAL(e.target.value)}
                      onBlur={(e) => handleChangeOAL(e.target.value)}
                    wrapperClassName={`awb-prefix ${isRTL ? 'rtl' : ''}`}
                    // error={t("ER048", { ns: "errors" })}
                    // isOnlyErrorBorder
                    />

                    <CommonInput
                      type="number"
                      label={t("COMMON.AWB_NUMBER")}
                      value={awbNumber}
                      disabled={!isInterlineAgent && awbValueEnable}
                      onChange={(e) => handleChange(e.target.value)}
                      onBlur={(e) => validateAWB(e.target.value)}
                      error={
                        showValidation
                          ? t("ER048", { ns: "errors" })
                          : ""
                      }
                     wrapperClassName={`awb-suffix ${isRTL ? 'rtl' : ''}`}

                    />
                  </div>
                </div>
              </div>
              {/* <div className="awbSpotWrap-container">
                  
                    {isInterlineAgent && (                    
                      <div className="l-checkbox">
                      <input
                        id={`pickAWB`}
                        type="checkbox"
                        checked={pickAwb}
                        onChange={(e) => {
                        setOalValue("607");
                        handlePickAwbChange(e.target.checked);
                        if (e.target.checked) {
                          setAwbValueEnable(true);
                        } else {
                          setAwbValueEnable(false);
                        }
                      }}
                      />
                      <label htmlFor={`pickAWB`} className="mb-0">
                        {t("BOOKING_SUMMARY.AUTOPICK_AWB")}
                      </label>
                    </div>
                    )}
                    
                      <div
                        className="awb-container"
                         
                      >
                  <div className={`form-group awb-input-section`}>
                    <CommonInput
                      type="number"
                    label={t("COMMON.PREFIX")}
                    value={awbValueEnable ? "607" : oalValue}
                   
                   disabled={awbValueEnable ? true : false}
                    onChange={(e) => {
                              handleChangeOAL(e.target.value);
                            }}
                    onBlur={(e) => {
                      handleChangeOAL(e.target.value);
                    }}
                    wrapperClassName={`awb-prefix`}
                    // error= {t("ER048", { ns: "errors" })}
                    // isOnlyErrorBorder
                    />

                    <CommonInput
                      type="number"
                      label={t("COMMON.AWB_NUMBER")}
                       value={awbNumber}
                        disabled={awbValueEnable ? true : false}
                        onChange={(e) => {
                          handleChange(e.target.value);
                        }}
                        onBlur={(e) => {
                          validateAWB(e.target.value);
                          if (e.target.value) {
                            //setPickAwb(false)
                          }
                        }}
                        error={
                          showValidation
                            ? t("ER048", { ns: "errors" })
                            : ""
                        }
                      wrapperClassName={"awb-suffix"}
                      
                        />
                              </div>


















                      
                      </div>

                     
                    
                  
                </div> */}

            </div>
          )}
          {showUpdateConfirmationPopup.show && <MiniPopup type="Warning" mainMsg={showUpdateConfirmationPopup.message} subMsg={t('COMMON.PROCEED_CONFIRMATION')} onCancel={handleUpdateConfirmationCancel} onConfirm={handleUpdateConfirmationConfirm} />}
          {!isModifyBooking && (
            <div className="book-now-button-container">
              <button
                type="button"
                disabled={disable}
                className="col-12 col-lg-auto primary-button"
                onClick={() => handleBookNow()}
              >
                {t("BOOKING_SUMMARY.BOOK")}
              </button>
            </div>
          )}
          {/* {!isModifyBooking && (
              <div className="col-12 p-l-0 pr-0 book-now-button">
                <button
                  type="button"
                  disabled={disable}
                  className="col-12 col-lg-auto primary-button l-btn--large "
                  onClick={() => handleBookNow()}
                >
                  {t("BOOKING_SUMMARY.BOOK")}
                </button>
              </div>
            )} */}
          {isModifyBooking && (
            <div className="book-now-button-container">
              <button
                type="button"
                className="secondary-button mr-3"
                onClick={() => handleBack()}
              >
                {t("COMMON.BACK_BUTTON")}
              </button>
              <button
                type="button"
                className="primary-button"
                onClick={() => setUpdateBooking()}
              >
                {t("COMMON.CONFIRM")}
              </button>
            </div>
          )}
        </div>
        {/* </div> */}
      </div>
    </>


  );
};
const mapStateToProps = ({ updateBooking, validateBooking, listFlight }) => ({
  updateBookingResponse: updateBooking.response,
  updateBookingError: updateBooking.error,
  validateBookingResponse: validateBooking.response,
  validateBookingError: validateBooking.error,
  resultSet: listFlight.resultSet,
});
const mapDispatchToProps = (dispatch, message) => ({
  updateBookingRequest: (
    awbNumber,
    searchFormData,
    selectedFlight,
    spotRatePayload
  ) => {
    dispatch(
      updateBooking(awbNumber, searchFormData, selectedFlight, spotRatePayload)
    );
  },
  clearUpdateBookingResponse: (awbNumber, searchFormData, selectedFlight) => {
    dispatch(clearUpdateBooking());
  },
  validateBookingRequest: (awbNumber, searchFormData, selectedFlight) => {
    dispatch(validateBooking(awbNumber, searchFormData, selectedFlight));
  },
  clearValidateBookingResponse: () => {
    dispatch(clearValidateBooking());
  },
  triggerListFlight: (searchFormData) => {
    dispatch(loadListFlight(searchFormData));
  },
  triggerclearListFlight: () => {
    dispatch(clearListFlight());
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(ViewQuote);